<!--  -->
<template>
	<div class="ContactUs">
		<div class="contact-form">
			<h1>{{ touzizhe }}</h1>
			<div class="contact-input">
				<input type="text" v-model="name" :placeholder="xm" />
				<input type="text" v-model="email" :placeholder="yx" />
				<input type="text" v-model="phone" :placeholder="dh" />
				<textarea class="liuyan" v-model="msg" type="text" :placeholder="ly" />
			</div>
			<div class="submit" @click="submit()">{{ tijiao }}</div>
			<div class="contact-hint">
				<h1>{{ hint1 }}</h1>
				<h1>{{ hint2 }}</h1>
			</div>
		</div>
	</div>
</template>
<script>
	//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
	//例如：import 《组件名称》 from '《组件路径》';

	export default {
		//import引入的组件需要注入到对象中才能使用
		components: {},
		data() {
			//这里存放数据
			return {
				xm: "",
				yx: "",
				dh: "",
				ly: "",
				touzizhe: "", //投资者联络
				tijiao: "", //提交
				hint1: "", //如您有任何疑问，可随时通过专用电子邮箱 ir@broncuschina.com联络我们。
				hint2: "", //谢谢您的关注和支持！
				name: "",
				email: "",
				phone: "",
				msg: "",
			};
		},
		//监听属性 类似于data概念
		computed: {},
		//监控data中的数据变化
		watch: {},
		//方法集合
		methods: {
			submit() {
				console.log(this.name, this.email, this.phone, this.msg);
				const that = this;
				var formData = new FormData();
				formData.append("act", "tzzll");
				formData.append("username", that.name);
				formData.append("mobile", that.phone);
				formData.append("email", that.email);
				formData.append("content", that.msg);

				if (that.name == "") {
					alert("Please fill in your name!");
					return false;
				}

				if (!that.email.match(/^[\w\-\.]+@[\w\-\.]+(\.\w+)+$/)) {
					alert("Please fill in the correct email address!");
					return false;
				}

				if (that.phone == "") {
					alert("Please fill in the telephone number!");
					return false;
				}

				if (that.msg == "") {
					alert("Please fill a content!");
					return false;
				}

				$.ajax({
					url: "/index.php?s=Home/Api/get_data",
					type: "post",
					datatype: "json",
					data: formData,
					processData: false,
					contentType: false,
					success: function(ret) {
						var obj = JSON.parse(ret); //json数据转为数组
						if (obj.code == "0000") {
							alert(obj.message);
							return true;
						} else {
							alert(obj.message);
							return false;
						}
					},
					error: function(err) {
						console.log("ajax错误");
					},
				});
			},
			//文字翻译
			get_fanyi() {
				const that = this;
				$.ajax({
					url: "/index.php?s=Home/Api/get_data",
					type: "get",
					datatype: "json",
					data: {
						act: "get_fanyi",
					},
					success: function(ret) {
						var obj = JSON.parse(ret); //json数据转为数组
						if (obj.code == "0000") {
							that.xm = obj.data["xm"];
							that.yx = obj.data["yx"];
							that.dh = obj.data["dh"];
							that.ly = obj.data["ly"];
							that.tijiao = obj.data["tj"];
							that.touzizhe = obj.data["touzizhe"];
							that.hint1 = obj.data["rnyrhyw"];
							that.hint2 = obj.data["xxnd"];
						}
					},
					error: function(err) {
						console.log("ajax错误");
					},
				});
			},
		},
		//生命周期 - 创建完成（可以访问当前this实例）
		created() {},
		//生命周期 - 挂载完成（可以访问DOM元素）
		mounted() {
			this.get_fanyi();
		},
		beforeCreate() {}, //生命周期 - 创建之前
		beforeMount() {}, //生命周期 - 挂载之前
		beforeUpdate() {}, //生命周期 - 更新之前
		updated() {}, //生命周期 - 更新之后
		beforeDestroy() {}, //生命周期 - 销毁之前
		destroyed() {}, //生命周期 - 销毁完成
		activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
	};
</script>
<style lang='scss' scoped>
	//@import url(); 引入公共css类
	@import "../../../scss/public.scss";

	.ContactUs {
		width: 100%;

		.contact-form {
			width: $main-width;
			margin: 20px auto 100px;

			h1 {
				color: #193b95;
				font-size: 1.4rem;
				text-align: center;
				font-family: kunbo;
			}

			.contact-input {
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;

				input {
					margin-top: 28px;
					width: 32%;
					height: 70px;
					background: #ffffff;
					border: 1px solid #d8d8d8;
					border-radius: 5px;
					padding: 0 22px;
					font-size: 1.2rem;
					color: #c4c4c4;
					font-family: kunbo;
				}

				input::-webkit-input-placeholder {
					font-size: 1.2rem;
					color: #c4c4c4;
					font-family: kunbo;
				}

				.liuyan::-webkit-input-placeholder {
					font-size: 1.2rem;
					color: #c4c4c4;
					font-family: kunbo;
				}

				.liuyan {
					margin-top: 28px;
					width: 100%;
					height: 168px;
					background: #ffffff;
					border: 1px solid #d8d8d8;
					border-radius: 5px;
					padding: 10px 22px;
					font-size: 1.2rem;
					color: #c4c4c4;
					font-family: kunbo;
				}
			}

			.submit {
				width: 300px;
				margin: 60px auto;
				padding: 16px 0;
				text-align: center;
				background: #f8ad17;
				border-radius: 5px;
				color: #fff;
				font-size: 1.5rem;
				font-family: kunbo;
			}

			.contact-hint {
				text-align: center;

				h1 {
					margin: 14px 0;
					color: #2093d7;
					font-size: 1.3rem;
				}
			}
		}
	}

	@media screen and (max-width: $main-width) {
		.ContactUs {
			.contact-form {
				width: 100%;
				padding: 0 10px;

				.contact-input {
					flex-direction: column;

					input {
						width: 100%;
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/investor/ContactUs.vue